// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-Blocks-MultipleChoice-control-SuggestibleMultipleChoice-module__suggestionPending";
export { _1 as "suggestionPending" }
